import React from "react";
import SectionHeader, { CTABar } from "@/components/site/SectionHeader";
import { PROCESS } from "@/components/site/content";

const IMG = "https://images.pexels.com/photos/12903168/pexels-photo-12903168.jpeg";

export default function AboutPage() {
  return (
    <div data-testid="about-page">
      <section className="section-pad bg-white">
        <div className="container-tight grid lg:grid-cols-[1.1fr,1fr] gap-14 items-center">
          <div>
            <p className="overline mb-4">About CRETRE</p>
            <h1 className="font-serif text-4xl lg:text-6xl text-navy-800 leading-[1.05]">A workforce & HR solutions partner for businesses across India.</h1>
            <div className="mt-6 space-y-5 text-muted-foreground leading-relaxed">
              <p>CRETRE is a workforce and HR solutions company providing manpower, recruitment, payroll, compliance and workforce management services to businesses across India.</p>
              <p>Our focus is simple — connect businesses with the right people, simplify workforce management and create scalable HR solutions that support business growth.</p>
              <p>With a dedicated recruitment team and experience across multiple industries, CRETRE supports clients from frontline workforce hiring to professional and managerial recruitment.</p>
            </div>
          </div>
          <div className="rounded-3xl overflow-hidden border border-border">
            <img src={IMG} alt="CRETRE team" className="w-full h-[440px] lg:h-[560px] object-cover" />
          </div>
        </div>
      </section>

      <section className="section-pad bg-secondary/40">
        <div className="container-tight">
          <SectionHeader overline="Our Approach" title="Understand → Source → Screen → Deploy → Manage → Support" subtitle="A structured, transparent process that scales from single hires to large workforce deployments." />
          <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {PROCESS.map((p, i) => (
              <div key={p.step} data-testid={`about-step-${i}`} className="relative bg-white rounded-2xl border border-border p-8 hover:border-gold-400/60 transition-colors">
                <div className="font-serif text-5xl text-gold-500/70">{p.step}</div>
                <h3 className="mt-3 font-serif text-2xl text-navy-800">{p.title}</h3>
                <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTABar
        title="Partner with CRETRE."
        text="From recruitment to payroll — one trusted partner for all your workforce needs."
        primary={{ to: "/employers", label: "Start a Requirement" }}
        secondary={{ to: "/contact", label: "Contact Us" }}
        testid="about-cta-bar"
      />
    </div>
  );
}
